import {FONTS, FONTS_URL, FONTS_WITHOUT_BOLD} from "../../../config";

export const loadFonts = () => {
    return new Promise((resolve) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = FONTS_URL;
        document.head.appendChild(link);

        const fontTestDiv = document.createElement('div');
        fontTestDiv.style.position = 'absolute';
        fontTestDiv.style.left = '-9999px';
        fontTestDiv.style.visibility = 'hidden';
        document.body.appendChild(fontTestDiv);

        FONTS.forEach(font => {
            const testElement = document.createElement('div');
            testElement.style.fontFamily = `"${font}", sans-serif`;
            testElement.innerHTML = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789 ${font}`;
            testElement.style.fontSize = '20px';
            fontTestDiv.appendChild(testElement);

            if (!FONTS_WITHOUT_BOLD.includes(font)) {
                const boldElement = document.createElement('div');
                boldElement.style.fontFamily = `"${font}", sans-serif`;
                boldElement.style.fontWeight = 'bold';
                boldElement.innerHTML = `BOLD: ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789 ${font}`;
                boldElement.style.fontSize = '20px';
                fontTestDiv.appendChild(boldElement);
            }
        });

        setTimeout(() => {
            console.log("Fonts preloaded");
            document.body.removeChild(fontTestDiv);
            resolve();
        }, 1000);
    });
};
